export default __webpack_public_path__ + "static/media/account.59bf3284.svg";